import React from "react";

/**
 * A reusable component that renders content with a highlighted background.
 */
interface HighlightedSpanProps {
  children: React.ReactNode;
  className?: string;
}

function HighlightedSpan({ children, className }: HighlightedSpanProps) {
  return (
    <span
      className={`px-1 py-0.5 ${className}`}
      style={{
        // Ensures background and padding are applied to each wrapped line individually
        // instead of treating the element as one continuous box. This prevents the
        // background from stretching across the full line width when text wraps.
        boxDecorationBreak: "clone",
        WebkitBoxDecorationBreak: "clone", // Safari support
      }}
    >
      {children}
    </span>
  );
}

export default HighlightedSpan;
